import { render } from "./ImageDrawer.vue?vue&type=template&id=9becc470"
import script from "./ImageDrawer.vue?vue&type=script&lang=js"
export * from "./ImageDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__